<template lang="pug">
base-dialog(
  :value="value",
  @input="$emit('input', $event)",
  titulo="Logs de Operações",
  :max-width="maxWidth",
  :min-width="minWidth",
  :mostrar-confirmar="false",
  texto-cancelar="Fechar"
)
  v-tabs.logs-abas(
    v-if="abas.length",
    :value="indiceAba",
    height="40",
    @change="trocarAba"
  )
    v-tab.text-none(v-for="aba in abas", :key="aba.value") {{ aba.texto }}

  v-card.pa-2(outlined, elevation="0", :class="{ 'mt-2': abas.length }")
    .d-flex.align-center.justify-space-between.gap-2.logs-acoes(
      :class="{ 'logs-acoes--oculta': carregando }"
    )
      v-chip(
        v-if="busca",
        x-small,
        color="blue lighten-4",
        text-color="blue darken-3"
      ) {{ totalFiltrados }} resultado(s)
      v-spacer
      v-text-field.preview-field.logs-search(
        :value="busca",
        @input="$emit('update:busca', $event)",
        :placeholder="placeholderBusca",
        prepend-inner-icon="mdi-magnify",
        clearable,
        dense,
        filled,
        rounded,
        hide-details,
        single-line
      )
      v-btn.btn-action.text-none.ml-1(
        v-if="!plano",
        outlined,
        small,
        :disabled="!grupos.length",
        @click="$emit('expandir')"
      ) Expandir
      v-btn.btn-action.text-none.ml-1(
        v-if="!plano",
        outlined,
        small,
        :disabled="!grupos.length",
        @click="$emit('recolher')"
      ) Recolher

    .logs-loader.mt-2
      v-progress-linear(
        :active="carregando",
        indeterminate,
        color="blue",
        height="2"
      )

    .logs-conteudo.mt-2(
      :class="{ 'logs-conteudo--com-abas': abas.length, 'logs-conteudo--plano': plano }"
    )
      .logs-empty.text-center(v-if="!carregando && semRegistros")
        v-icon.empty-state-icon(size="64", color="blue lighten-3") mdi-clipboard-text-clock-outline
        .empty-state-title.mt-3 {{ textoVazioTitulo }}
        .empty-state-subtitle.mt-1 {{ textoVazioSubtitulo }}

      v-data-table.logs-tabela-plana(
        v-else-if="plano",
        dense,
        fixed-header,
        :headers="headers",
        :items="itens",
        :items-per-page="50",
        :footer-props="footerProps",
        item-key="id",
        width="100%",
        elevation="0"
      )
        template(v-slot:[`item.${campoNome}`]="{ item: linha }")
          v-chip.log-item-status-chip(
            v-if="corChip",
            x-small,
            :color="corChip(linha[campoNome]).color",
            :text-color="corChip(linha[campoNome]).textColor"
          ) {{ formatarNome(linha[campoNome]) }}
          span.log-item-nome(v-else) {{ formatarNome(linha[campoNome]) }}

        template(v-slot:item.usuario="{ item: linha }")
          span.log-item-usuario {{ linha.usuario || "—" }}

        template(v-slot:item.motivo="{ item: linha }")
          span.log-item-motivo(:title="linha.motivo") {{ linha.motivo || "—" }}

        template(v-slot:item.dataoperacao="{ item: linha }")
          span.log-item-data {{ formatarDataHora(linha.dataoperacao) }}

      v-expansion-panels.logs-panels(
        v-else,
        :value="paineisAbertos",
        @change="$emit('update:paineis-abertos', $event)",
        multiple,
        elevation="0"
      )
        v-expansion-panel.log-panel(
          v-for="grupo in grupos",
          :key="grupo.codigoempresa",
          elevation="0"
        )
          v-expansion-panel-header.log-panel-header.py-2.px-3
            template(v-slot:actions)
              v-icon(color="primary") $expand
            .d-flex.align-center.gap-3.flex-grow-1
              .log-panel-codigo {{ grupo.codigoempresa }}
              span.log-empresa-nome.ml-2 {{ grupo.nomeempresa }}
              v-spacer
              v-chip.log-panel-count(
                x-small,
                color="blue lighten-4",
                text-color="blue darken-3"
              ) {{ grupo.itens.length }} log(s)

          v-expansion-panel-content.log-panel-content
            v-data-table(
              dense,
              :headers="headers",
              :items="grupo.itens",
              :footer-props="footerPropsPara(grupo.itens.length)",
              item-key="id",
              width="100%",
              elevation="0"
            )
              template(v-slot:[`item.${campoNome}`]="{ item: linha }")
                v-chip.log-item-status-chip(
                  v-if="corChip",
                  x-small,
                  :color="corChip(linha[campoNome]).color",
                  :text-color="corChip(linha[campoNome]).textColor"
                ) {{ formatarNome(linha[campoNome]) }}
                span.log-item-nome(v-else) {{ formatarNome(linha[campoNome]) }}

              template(v-slot:item.ativo="{ item: linha }")
                .d-flex.align-center.justify-center
                  span.log-item-ativo-text(
                    :class="linha.ativo ? 'log-item-ativo-text--on' : 'log-item-ativo-text--off'"
                  )
                    v-icon(
                      x-small,
                      left,
                      :color="linha.ativo ? 'green darken-2' : 'red darken-2'"
                    ) {{ linha.ativo ? "mdi-check-circle" : "mdi-cancel" }}
                    span {{ linha.ativo ? "Ativo" : "Inativo" }}

              template(v-slot:item.tipooperacao="{ item: linha }")
                v-chip.log-item-tipo-chip(
                  x-small,
                  label,
                  :color="corTipoOperacao(linha.tipooperacao)",
                  :text-color="corTipoOperacao(linha.tipooperacao) === 'grey' ? 'grey darken-2' : 'white'"
                ) {{ descricaoTipoOperacao(linha.tipooperacao) }}

              template(v-slot:item.usuario="{ item: linha }")
                span.log-item-usuario {{ linha.usuario || "—" }}

              template(v-slot:item.motivo="{ item: linha }")
                span.log-item-motivo(:title="linha.motivo") {{ linha.motivo || "—" }}

              template(v-slot:item.dataoperacao="{ item: linha }")
                span.log-item-data {{ formatarDataHora(linha.dataoperacao) }}
</template>

<script>
import BaseDialog from "./BaseDialog";

export default {
  name: "LogsDialog",

  components: {
    BaseDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    grupos: {
      type: Array,
      default: () => []
    },
    carregando: {
      type: Boolean,
      default: false
    },
    busca: {
      type: String,
      default: ""
    },
    placeholderBusca: {
      type: String,
      default: "Buscar por item, usuário ou motivo"
    },
    totalFiltrados: {
      type: Number,
      default: 0
    },
    headers: {
      type: Array,
      default: () => []
    },
    // Campo do registro usado na primeira coluna (ex.: nomemenu, nomesistema).
    campoNome: {
      type: String,
      default: "nome"
    },
    // Permite tratar o valor exibido (ex.: limpar mnemônicos "&" dos menus).
    formatarNome: {
      type: Function,
      default: valor => valor
    },
    // Opcional: recebe o valor da coluna de "campoNome" e devolve { color, textColor }.
    // Quando informado, o valor é exibido como chip colorido em vez de texto.
    corChip: {
      type: Function,
      default: null
    },
    paineisAbertos: {
      type: Array,
      default: () => []
    },
    footerProps: {
      type: Object,
      default: () => ({})
    },
    textoVazioTitulo: {
      type: String,
      default: "Nenhum log encontrado"
    },
    textoVazioSubtitulo: {
      type: String,
      default: "Não foram encontrados registros de operações para este cliente."
    },
    // Opcional: [{ value, texto }]. A aba ativa é controlada pela tela (abaAtiva).
    abas: {
      type: Array,
      default: () => []
    },
    abaAtiva: {
      type: String,
      default: null
    },
    plano: {
      type: Boolean,
      default: false
    },
    itens: {
      type: Array,
      default: () => []
    },
    maxWidth: {
      type: [String, Number],
      default: 1600
    },
    minWidth: {
      type: [String, Number],
      default: 1200
    }
  },

  computed: {
    semRegistros() {
      return this.plano ? this.itens.length === 0 : this.grupos.length === 0;
    },

    indiceAba() {
      const indice = this.abas.findIndex(aba => aba.value === this.abaAtiva);
      return indice < 0 ? 0 : indice;
    }
  },

  methods: {
    trocarAba(indice) {
      const aba = this.abas[indice];
      if (aba && aba.value !== this.abaAtiva) this.$emit("update:aba-ativa", aba.value);
    },

    footerPropsPara(qtd) {
      return qtd > 50 ? this.footerProps : { showCurrentPage: false };
    },

    corTipoOperacao(tipo) {
      if (tipo === "C") return "success";
      if (tipo === "A") return "primary";
      return "grey";
    },

    descricaoTipoOperacao(tipo) {
      if (tipo === "C") return "Criado";
      if (tipo === "A") return "Atualizado";
      return tipo || "—";
    },

    // Converte ISO-8601 (ex: "2026-07-22T12:55:10.000Z") para "dd/mm/aaaa HH:MM:SS"
    // sem usar Date/Intl — apenas split e operações de string.
    formatarDataHora(valor) {
      if (!valor || typeof valor !== "string") return "—";
      const separador = valor.indexOf("T");
      if (separador < 0) return "—";
      const data = valor.substring(0, separador);
      const tempo = valor.substring(separador + 1);
      const dataSplit = data.split("-");
      if (dataSplit.length !== 3) return "—";
      const [ano, mes, dia] = dataSplit;
      if (!ano || !mes || !dia) return "—";
      const tempoSplit = tempo.split(":");
      if (tempoSplit.length < 2) return "—";
      const [hora, minuto] = tempoSplit;
      const segundosSplit = (tempoSplit[2] || "").split(".");
      const segundo = (segundosSplit[0] || "").replace(/\D/g, "");
      if (!hora || !minuto || segundo === "") return "—";
      return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
    }
  }
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.logs-acoes--oculta {
  visibility: hidden;
}

.logs-loader {
  position: relative;
  height: 2px;
}

.logs-conteudo {
  height: calc(100vh - 320px);
  overflow-y: scroll;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
}

.logs-conteudo--com-abas {
  height: calc(100vh - 368px);
}

.logs-conteudo--plano {
  overflow-y: hidden;
}

.logs-tabela-plana {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.logs-tabela-plana ::v-deep .v-data-table__wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}

.logs-search {
  max-width: 480px;
}

.logs-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
}

.logs-panels {
  flex: 0 0 auto;
  border: 1px solid #e8eef4;
  border-radius: 6px;
  overflow: hidden;
}

.logs-panels .v-expansion-panel::before {
  box-shadow: none;
}

.log-panel {
  border-bottom: 1px solid #e8eef4;
}

.log-panel:last-child {
  border-bottom: none;
}

.log-panel-header {
  font-size: 13px;
  min-height: 48px;
}

.log-panel-count {
  font-weight: 600 !important;
  font-size: 10px !important;
  height: 18px !important;
}

.log-panel-content {
  padding: 8px 4px 12px 4px !important;
}

.log-panel-codigo {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #1976d2;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.log-empresa-nome {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
}

.log-item-nome {
  font-size: 13px;
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
}

.log-item-usuario {
  font-size: 12px;
  color: #424242;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
}

.log-item-motivo {
  font-size: 12px;
  color: #555;
  white-space: normal;
  word-break: break-word;
  vertical-align: middle;
}

.log-item-data {
  font-size: 12px;
  color: #424242;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.log-item-ativo-text {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.log-item-ativo-text--on {
  color: #2e7d32;
}

.log-item-ativo-text--off {
  color: #c62828;
}

.log-item-status-chip {
  font-weight: 700 !important;
  font-size: 10px !important;
  height: 18px !important;
  padding: 0 8px !important;
}

.log-item-tipo-chip {
  font-weight: 700 !important;
  font-size: 10px !important;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.btn-action {
  height: 30px !important;
  min-width: 0 !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  border: 1px solid #d0d7de !important;
  color: #57606a !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}
</style>
